import type { ReportColumn } from '../models/column.types'
import type { ReportRow } from '../models/report.types'

import { isComparisonColumn } from './comparisonColumns'
import { isMediaColumn } from './reportCellKind'

import type { TableColumn } from '@/shared/ui'

const MEDIA_COLUMN_WIDTH = 96

/** Narrow module-08 columns into module-02's generic grid contract. */
export function toTableColumns<Row extends ReportRow = ReportRow>(
  columns: readonly ReportColumn[],
): TableColumn<Row>[] {
  return columns
    .filter((column) => !column.invisible)
    .map((column) => {
      const media = isMediaColumn(column)
      const width = media
        ? Math.min(column.width ?? MEDIA_COLUMN_WIDTH, MEDIA_COLUMN_WIDTH)
        : column.width
      const maxWidth = media
        ? Math.min(column.maxWidth ?? MEDIA_COLUMN_WIDTH, MEDIA_COLUMN_WIDTH)
        : column.maxWidth

      return {
        field: column.field as Extract<keyof Row, string>,
        header: column.header,
        ...(column.description === undefined ? {} : { description: column.description }),
        numeric: column.numeric ?? false,
        frozen: column.frozen ?? false,
        sortable: column.sortable ?? true,
        resizable: column.resizable ?? true,
        ...(isComparisonColumn(column) ? { supplementary: true } : {}),
        ...(width === undefined ? {} : { width }),
        ...(column.minWidth === undefined ? {} : { minWidth: column.minWidth }),
        ...(maxWidth === undefined ? {} : { maxWidth }),
      }
    })
}
